import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

import {
  getLeadStatuses,
  deleteLeadStatus,
} from "../../services/leadService";

import AddLeadStatusModal from "./AddLeadStatusModal";
import MasterLayout from "../../masterLayout/MasterLayout";
import "./LeadStatus.css";

const LeadStatusList = () => {
  const [statuses, setStatuses] = useState([]);
  const [showAdd, setShowAdd] = useState(false);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    loadStatuses();
  }, []);

  /* =========================
     LOAD STATUSES
  ========================= */
  const loadStatuses = async () => {
    const res = await getLeadStatuses();
    if (res.status === "success") {
      setStatuses(res.data || []);
    }
  };

  /* =========================
     DELETE STATUS
  ========================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this status?")) return;

    const res = await deleteLeadStatus(id);
    if (res.status === "success") {
      toast.success("Status deleted");
      loadStatuses();
    } else {
      toast.error(res.message || "Delete failed");
    }
  };

  /* =========================
     FILTER (REMOVE INVALID ROWS)
  ========================= */
  const filtered = statuses
    .filter((s) => s.name && s.name.trim() !== "") // 🔥 FIX BLANK ROW
    .filter((s) =>
      s.name.toLowerCase().includes(search.toLowerCase())
    );

  /* =========================
     PAGINATION
  ========================= */
  const total = filtered.length;
  const perPage = limit === "all" ? total : Number(limit);
  const start = (page - 1) * perPage;
  const paginated = filtered.slice(start, start + perPage);
  const totalPages = Math.ceil(total / perPage);

  return (
    <MasterLayout>
      <div className="status-wrapper">
        <div className="status-card">

          {/* HEADER */}
          <div className="status-header">
            <h5>Lead Status</h5>
            <button className="btn-add" onClick={() => setShowAdd(true)}>
              <FaPlus /> Add Status
            </button>
          </div>

          {/* FILTER BAR */}
          <div className="status-filters">
            <input
              placeholder="Search status..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />

            <select
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                setPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value="all">All</option>
            </select>
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <table className="status-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status Name</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginated.map((s) => (
                  <tr key={s.id}>
                    <td>{s.id}</td>
                    <td>{s.name || "-"}</td>
                    <td>{s.is_active ? "Yes" : "No"}</td>
                    <td>
                      {s.name ? (
                        <button
                          className="icon-btn delete"
                          onClick={() => handleDelete(s.id)}
                        >
                          <FaTrash />
                        </button>
                      ) : (
                        <span style={{ color: "#999" }}>—</span>
                      )}
                    </td>
                  </tr>
                ))}

                {paginated.length === 0 && (
                  <tr>
                    <td colSpan="4" align="center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          {limit !== "all" && totalPages > 1 && (
            <div className="pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Prev
              </button>

              <span>
                Page {page} / {totalPages}
              </span>

              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>

        {/* ADD MODAL */}
        {showAdd && (
          <AddLeadStatusModal
            onClose={() => setShowAdd(false)}
            onSuccess={loadStatuses}
          />
        )}
      </div>
    </MasterLayout>
  );
};

export default LeadStatusList;
